import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Tabs, Tab, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {mediaQuery} from '../../core/browser'
import extract from '../../core/extract'
import {connectForm, controlledField, nodeHasValue} from '../../core/redux/form'
import SearchBar from '../../core/components/SearchBar'
import TypeaheadBar, {matcher} from '../../core/components/TypeaheadBar'
import Tags from '../../core/components/Tags'
import Tag from '../../core/components/Tag'
import Icon from '../../core/components/Icon'
import {ProviderCoverageCriteria} from '../models'
import {PROVIDER_COVERAGE_CRITERIA_UPDATED, DEFAULT_PROVIDER_COVERAGE_QUERY, loadProviderCoverage, updateProviderCoverageCriteria} from '../actions'
import i18n from '../i18n'
import style from './ProviderCoverageSearchBar.less'

function repairActivities(reference, activities = []) {
    activities.forEach((activity) => {
        if (activity.label) return

        const referenceActivity = reference.find((a) => a.uid == activity.uid)
        if (referenceActivity) {
            // mutate so we don't trigger actors
            activity.label = referenceActivity.label
        } else {
            console && console.warn('activity "' + activity.uid + '" doesn\'t exist in referentiel')
        }
    })

    return activities
}

class ProviderCoverageSearchBar extends Component {
    static propTypes = {
    }

    componentWillMount() {
        const {dispatch, criteria, reference} = this.props

        const activityUids = repairActivities(reference, criteria && criteria.activityUids)
        dispatch(updateProviderCoverageCriteria({activityUids}))
    }

    _search() {
        const {dispatch, criteria} = this.props

        const nextCriteria = {...criteria, department: null, city: null}
        dispatch(updateProviderCoverageCriteria(nextCriteria))
        dispatch(loadProviderCoverage({...DEFAULT_PROVIDER_COVERAGE_QUERY, ...nextCriteria}))
    }

    render() {
        const {dispatch, form, criteria, query, reference} = this.props

        const activitySource = matcher({
            source: reference,
            identify: (a) => a.label
        })

        const tabTitle = (label, icon) => (
            <span className={style.tabTitle}>
                <Icon icon={icon} size='sm' />
                {label}
            </span>
        )

        const zipCodesField = (field) => {
            const value = query && query.zipCodes
            return {...field, value}
        }

        const footer = (nodeHasValue(form.activityUids, form.department, form.city) || (query && query.zipCodes)) && (
            <div className={style.footer}>
                {nodeHasValue(form.department) && (
                    <h4>
                        {i18n.department}
                        <small>
                            <Tag
                                display={(d) => d.name}
                                {...form.department()} />
                        </small>
                    </h4>
                )}
                {nodeHasValue(form.city) && (
                    <h4>
                        {i18n.city}
                        <small>
                            <Tag
                                display={(c) => c.name}
                                {...form.city()} />
                        </small>
                    </h4>
                )}
                {query && query.zipCodes && (
                    <h4>
                        {i18n.zipCodes}
                        <small>
                            <Tag
                                {...zipCodesField(form.zipCodes())} />
                        </small>
                    </h4>
                )}
                <Tags
                    label={i18n.activity + ' :'}
                    labelClassName='col-sm-2'
                    wrapperClassName='col-sm-10'
                    display={(a) => a.label}
                    {...form.activityUids()} />
            </div>
        )

        return (
            <SearchBar
                footer={footer}
                placeholder={extract(i18n.searchCoverage, mediaQuery())}>
                <Row>
                    <Col sm={8}>
                        <div className={style.content}>
                            <Tabs
                                bsStyle='cursors'
                                defaultActiveKey={1}
                                justified>
                                <Tab
                                    title={tabTitle(i18n.cities, 'customer')}
                                    eventKey={1}>
                                    <div className={style.zipCodes}>
                                        <Input
                                            type='textarea'
                                            rows={10}
                                            placeholder={i18n.zipCodesInfo}
                                            {...controlledField(form.zipCodes())} />
                                        <ButtonToolbar>
                                            <Button
                                                bsStyle='primary'
                                                bsSize='large'
                                                className={cx({disabled: !form.zipCodes.isValid()})}
                                                onClick={() => this._search()}>
                                                {i18n.validate}
                                            </Button>
                                        </ButtonToolbar>
                                    </div>
                                </Tab>
                                <Tab
                                    title={tabTitle(i18n.activities, 'customer')}
                                    eventKey={2}>
                                    <TypeaheadBar split
                                        source={activitySource}
                                        identify={(a) => a.uid}
                                        display={(a) => a.label}
                                        placeholder={extract(i18n.searchActivity, mediaQuery())}
                                        {...form.activityUids()} />
                                </Tab>
                            </Tabs>
                        </div>
                    </Col>
                </Row>
            </SearchBar>
        )
    }
}


ProviderCoverageSearchBar = connectForm({
    target: 'criteria',
    schema: ProviderCoverageCriteria.schema,
    action: PROVIDER_COVERAGE_CRITERIA_UPDATED
})(ProviderCoverageSearchBar)

ProviderCoverageSearchBar = connect((state) => ({
    criteria: state.provider.coverage.criteria,
    query: state.provider.coverage.query,
    reference: state.reference.activityRef
}))(ProviderCoverageSearchBar)

export default ProviderCoverageSearchBar


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderCoverageSearchBar.js